import { Button } from "./Button";

export function LoadError({
  what,
  onRetry,
  className = "",
}: {
  what: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div
      className={`flex items-center justify-between gap-4 rounded-lg border border-danger/40 bg-danger/10 p-4 ${className}`}
    >
      <div>
        <p className="text-sm font-medium text-danger">Couldn't load {what}.</p>
        <p className="text-sm text-foreground/70">
          Check your connection, then{" "}
          {onRetry ? "try again" : "reload the page"}.
        </p>
      </div>
      {onRetry && <Button onClick={onRetry}>Try again</Button>}
    </div>
  );
}
